import React, { FC } from 'react';

import {
	BUTTON_TYPES,
	EvButton,
	EvIcon,
	EvLoader,
	GrayCheckmarkIcon,
	SelectCheckboxIcon
} from '@evinced-private/ui-common';

import './SelectionStatusBar.scss';

interface ISelectionStatusBarProps {
	selectedCount: number;
	onCancel: () => void;
	processingMessage?: string | null;
	promptText?: string;
	itemName?: string;
	cancelButtonLabel?: string;
}

const DEFAULT_CANCEL_BUTTON_LABEL = 'Cancel';

export const SelectionStatusBar: FC<ISelectionStatusBarProps> = ({
	selectedCount,
	onCancel,
	processingMessage,
	promptText,
	itemName = 'item',
	cancelButtonLabel = DEFAULT_CANCEL_BUTTON_LABEL
}) => {
	return (
		<div className="selection-status-bar__row">
			{selectedCount === 0 && processingMessage == null && (
				<div className="selection-status-bar__prompt">
					<EvIcon icon={SelectCheckboxIcon} small className="selection-status-bar__button-icon" />
					{promptText}
				</div>
			)}

			{selectedCount !== 0 && processingMessage == null && (
				<div className="selection-status-bar__count-container">
					<div className="selection-status-bar__count">
						<EvIcon icon={GrayCheckmarkIcon} small className="selection-status-bar__button-icon" />
						{selectedCount} {itemName}
						{selectedCount !== 1 ? 's' : ''} selected
					</div>
					<EvButton
						title={cancelButtonLabel}
						onClick={onCancel}
						type={BUTTON_TYPES.SECONDARY_WITH_TRANSPARENT_BG}
						className="selection-status-bar__cancel-button"
					>
						{cancelButtonLabel}
					</EvButton>
				</div>
			)}

			{processingMessage !== null && (
				<div className="selection-status-bar__row">
					<div className="selection-status-bar__processing-container">
						<EvLoader message={processingMessage} />
					</div>
				</div>
			)}
		</div>
	);
};
